import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ConfigModule, ProcessModule, StateConfig, StateTransferType } from '@spartacus/core';
import { reducerProvider, reducerToken } from './store/reducers';
import { REVIEWS_FEATURE } from './store/reviews-state';

function reviewsStoreConfigFactory(): StateConfig {
  // if we want to reuse CATALOG_FEATURE const in config, we have to use factory instead of plain object
  return {
    state: {
      ssrTransfer: {
        keys: {
          [REVIEWS_FEATURE]: StateTransferType.TRANSFER_STATE,
        },
      },
    },
  };
}

@NgModule({
  imports: [
    ProcessModule.forRoot(),
    StoreModule.forFeature(REVIEWS_FEATURE, reducerToken),
    ConfigModule.withConfigFactory(reviewsStoreConfigFactory),
  ],
  providers: [reducerProvider],
})
export class ReviewsDataAccessModule {}
